/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import CheckBox from '../Checkbox/SVGCheckbox';
import styles from './index.styl';

const PickInput = ({ id, label, name, value, ...other }) => (
  <label htmlFor={id} styleName="input">
    <input type="checkbox" defaultValue={value} {...{ id, name }} {...other} />
    <div styleName="checker">
      <span styleName="unchecked">
        <CheckBox size={12} />
      </span>
      <span styleName="checked">
        <CheckBox size={12} checked />
      </span>
    </div>
    <If condition={label}>
      <span styleName="label">{label}</span>
    </If>
  </label>
);

PickInput.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.string,
};

export default CSSModules(PickInput, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/PickList/PickInput.jsx